var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHouse = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 17,
  "aria-hidden": "true"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#201D1D",
  fillRule: "evenodd",
  d: "M16.004 14.321c0 .857-.702 1.554-1.567 1.554h-2.1v-5.258c0-.602-.494-1.092-1.1-1.092H8.036c-.607 0-1.1.49-1.1 1.092v5.258h-2.1a1.56 1.56 0 0 1-1.568-1.554V6.884l6.368-5.572 6.368 5.572zM8.07 15.875h3.134V10.65H8.07zm11.197-7.434a.53.53 0 0 0-.186-.363L10.012.141a.57.57 0 0 0-.751 0L.192 8.078c-.235.205-.257.531-.051.793l.001.001a.55.55 0 0 0 .41.185.56.56 0 0 0 .392-.166l1.19-1.042v6.472C2.134 15.798 3.346 17 4.835 17h9.602c1.49 0 2.7-1.202 2.7-2.679V7.849l1.192 1.042a.55.55 0 0 0 .389.166.47.47 0 0 0 .383-.186.6.6 0 0 0 .165-.43z"
})));
export default SvgHouse;